<template>
  <v-dialog v-model="dialog" width="100vw" fullscreen hide-overlay
            transition="fade-transition" content-class="image-viewer">
    <v-card style="background-color: black;" tile>
      <v-toolbar dense flat absolute color="transparent">
        <v-spacer></v-spacer>
        <v-icon color="white" @click="dialog = false">$vuetify.icons.cancel</v-icon>
      </v-toolbar>

      <div class="image-viewer-swiper-container swiper-container" style="width: 100vw; height: 100vh;">
        <div class="image-viewer-swiper-wrapper swiper-wrapper">
          <div class="image-viewer-swiper-slide swiper-slide" v-for="(image, index) of images" :key="index">
            <div class="swiper-zoom-container-swiper-zoom-container swiper-zoom-container">
              <img :src="image">
<!--              <v-img :src="image" contain width="100vw" height="100vh" style="display: block;">-->
<!--                <template v-slot:placeholder>-->
<!--                  <v-layout fill-height align-center justify-center ma-0>-->
<!--                    <v-progress-circular indeterminate color="white"></v-progress-circular>-->
<!--                  </v-layout>-->
<!--                </template>-->
<!--              </v-img>-->
            </div>
          </div>
        </div>

        <div v-show="images.length > 1" class="image-viewer-swiper-pagination swiper-pagination"></div>
      </div>

    </v-card>
  </v-dialog>
</template>

<script>
  import Swiper from 'swiper';
  import 'swiper/dist/css/swiper.min.css';
  import { mapGetters, mapActions } from 'vuex';

  export default {
    name: 'ImageViewer',
    computed: {
      ...mapGetters([ 'imageViewer', 'images', 'selectedImageIndex' ]),
      dialog: {
        get () {
          return this.imageViewer;
        },
        set (flag) {
          this.toggleImageViewer({ flag });
        }
      }
    },
    data () {
      return {
        swiper: null
      };
    },
    mounted () {
      this.swiper = new Swiper('.image-viewer-swiper-container', {
        zoom: true,
        direction: 'horizontal',
        width: window.innerWidth,
        height: window.innerHeight,
        pagination: {
          el: '.image-viewer-swiper-pagination',
        },
      });
    },
    updated () {
      if (this.swiper) this.swiper.update();
      else {
        this.swiper = new Swiper('.image-viewer-swiper-container', {
          zoom: true,
          direction: 'horizontal',
          width: window.innerWidth,
          height: window.innerHeight,
          pagination: {
            el: '.image-viewer-swiper-pagination',
          },
        });
      }
      this.swiper.slideTo(this.selectedImageIndex);
    },
    methods: {
      ...mapActions([ 'toggleImageViewer' ]),
    }
  }
</script>

<style lang="scss">
  .image-viewer.v-dialog {
    margin: 0;
    overflow: hidden;
  }
</style>

<style lang="scss" scoped>
  /deep/.swiper-pagination {
    position: absolute;
    bottom: 0;
    width: 100%;

    .swiper-pagination-bullet {
      display: inline-block;
      width: 6px;
      height: 6px;
      opacity: 1;
      background: white;
      border-radius: 50%;
    }
    .swiper-pagination-bullet-active {
      background: #ec2f54;
    }
  }
</style>
